import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { Link, useLocation, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import logo from "../../assets/images/logo-light1.svg"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// import images
import Spinners from "components/Common/Spinner"
import toast from "react-hot-toast"
import { useInvestorRegisterMutation } from "store/api/investorapi/auth.api"
import { sanitizeIntegerInput } from "helpers/common"

const Register = () => {
  //meta title
  document.title = "Register | Prachay"

  const location = useLocation()
  const [trigger, { isLoading }] = useInvestorRegisterMutation()
  const [referralCodeDisabled, setReferralCodeDisabled] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const referralcode = queryParams.get("referralcode")
    if (referralcode) {
      validation.setFieldValue("referral_code", referralcode)
      setReferralCodeDisabled(true)
    }
  }, [location.search])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      email: "",
      phone: "",
      pan_no: "",
      referral_code: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Company name"),
      email: Yup.string().required("Please Enter Your Email"),
      pan_no: Yup.string()
        .required("PAN is required.")
        .matches(
          /^[A-Z]{5}[0-9]{4}[A-Z]$/,
          "PAN must be in the format AAAAA9999A."
        )
        .test("is-company-pan", "Please enter a valid PAN", function (value) {
          if (!value || value.length < 5) return true
          const fourthChar = value.charAt(3).toUpperCase()
          return fourthChar !== "P"
        }),
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
        .required("Please Enter Your Phone No."),
    }),
    onSubmit: (values) => {
      onRegister(values)
    },
  })

  const onRegister = async (params) => {
    try {
      const { data, message } = await trigger(params).unwrap()
      navigate(`/login`)
      toast.success(message, { id: "toastMessage" })
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <div className="account-pages">
      {/* <Container> */}
      <Row className="g-0">
        <Col md={7} lg={7} xl={7} className="p-0 m-0">
          <div className="log-in-blue-bg-cover">
            <div className="login-page-text">
              <h4>Managing your</h4>
              <h5>
                <span> CORPORATE TREASURY </span> was never so easy
              </h5>
              <p>Introducing Prachay ICDs</p>
            </div>
            <div className="login-page-bottom-text">
              <h4>DON'T LEAVE</h4>
              <h5>
                YOUR <span style={{ color: "#f0a634" }}>SURPLUS </span>{" "}
                UNMANAGED
              </h5>
            </div>
          </div>
        </Col>

        <Col md={5} lg={5} xl={5}>
          <div className="overflow-hidden login-form-wrapper px-1">
            <Card>
              <CardBody>
                <Link to="/" className="">
                  <img src={logo} alt="" height="40" />
                </Link>
                <div className="login-text mt-3">
                  <h4>Register account</h4>
                  <p>Please enter below details.</p>
                </div>

                <div className="pt-0">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-2">
                        <Label className="form-label">Company Name</Label>
                        <Input
                          name="name"
                          className="form-control"
                          placeholder={"Enter Company Name"}
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-2">
                        <Label className="form-label">Email Address</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Email Address"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-2">
                        <Label className="form-label">Phone No.</Label>
                        <Input
                          name="phone"
                          className="form-control"
                          placeholder="Phone no."
                          type="text"
                          onChange={(e) =>
                            sanitizeIntegerInput(
                              e,
                              validation.setFieldValue,
                              "phone"
                            )
                          }
                          onBlur={validation.handleBlur}
                          value={validation.values.phone || ""}
                          invalid={
                            validation.touched.phone && validation.errors.phone
                              ? true
                              : false
                          }
                        />
                        {validation.touched.phone && validation.errors.phone ? (
                          <FormFeedback type="invalid">
                            {validation.errors.phone}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-2">
                        <Label className="form-label">PAN</Label>
                        <Input
                          name="pan_no"
                          className="form-control"
                          placeholder="PAN"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.pan_no || ""}
                          invalid={
                            validation.touched.pan_no &&
                              validation.errors.pan_no
                              ? true
                              : false
                          }
                        />
                        {validation.touched.pan_no &&
                          validation.errors.pan_no ? (
                          <FormFeedback type="invalid">
                            {validation.errors.pan_no}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-2">
                        <Label className="form-label">Referral Code</Label>
                        <Input
                          name="referral_code"
                          className="form-control"
                          placeholder="Referral Code"
                          type="text"
                          disabled={referralCodeDisabled}
                          onChange={validation.handleChange}
                          value={validation.values.referral_code || ""}
                        />
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block position-relative"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading ? <Spinners /> : "Register Now"}
                        </button>
                      </div>

                      <div
                        className="mt-4 text-center"
                        style={{ fontSize: "15px" }}
                      >
                        Already have an account?{" "}
                        <Link
                          to="/login"
                          style={{ color: "#035ca1", fontWeight: "bold" }}
                        >
                          Login
                        </Link>
                      </div>
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default withRouter(Register)
